/* Reveals the rest of a review wall.
   Every review is in the page from the start — hidden with CSS, not fetched —
   so the count on the button is the real count and the content is there for
   search engines and for anyone with JavaScript off. */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pk-more]');
    if (!btn) return;
    var wall = btn.closest('[data-pk-reviews]');
    if (!wall) return;
    wall.classList.toggle('is-open');
    btn.textContent = wall.classList.contains('is-open')
      ? 'Show fewer reviews'
      : btn.getAttribute('data-label') || 'Show all reviews';
  });
  document.querySelectorAll('[data-pk-more]').forEach(function (b) {
    b.setAttribute('data-label', b.textContent.trim());
  });
})();
